import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import api from '../lib/api';
import MemberLayout from '../components/MemberLayout';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { RiskAlert } from '../components/RiskAlert';
import { ArrowLeft, CheckCircle2 } from 'lucide-react';

const SECTIONS = [['definition','Definisi'],['structure','Struktur Pola'],['identification','Identifikasi'],['characteristics','Karakteristik'],['confirmation','Konfirmasi'],['chart_illustration','Ilustrasi Chart'],['practice','Latihan']];
const CASE = [['market_context','Market Context'],['trend','Trend'],['pattern','Pattern'],['confirmation','Confirmation'],['potential_entry','Potential Entry'],['risk_area','Risk Area'],['potential_target','Potential Target'],['result','Result'],['lesson_learned','Lesson Learned']];

export default function Lesson() {
  const { lessonId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => api.get(`/academy/lessons/${lessonId}`).then(r => setData(r.data)).catch(e => { toast.error(e.response?.data?.detail || 'Gagal memuat'); navigate('/academy'); });
  useEffect(() => { load(); }, [lessonId]);

  const complete = async () => {
    setSaving(true);
    try { await api.post(`/academy/lessons/${lessonId}/complete`); toast.success('Lesson selesai'); await load(); }
    catch (e) { toast.error('Gagal'); } finally { setSaving(false); }
  };

  if (!data) return <MemberLayout><div className="h-64 flex items-center justify-center text-muted-foreground">Memuat...</div></MemberLayout>;
  const l = data.lesson; const c = l.content || {}; const rc = l.realtime_case;

  return (
    <MemberLayout>
      <Button variant="ghost" size="sm" onClick={() => navigate('/academy')} className="mb-4"><ArrowLeft className="h-4 w-4 mr-1" />Academy</Button>
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div><div className="text-sm text-amber-600 font-medium">{l.code}</div><h1 className="font-display text-2xl sm:text-3xl font-bold">{l.title}</h1></div>
        {data.completed && <span className="inline-flex items-center gap-1 text-emerald-600 text-sm"><CheckCircle2 className="h-4 w-4" />Selesai</span>}
      </div>

      <div className="mt-6 space-y-4">
        {rc ? (
          <Card className="p-6">
            <h3 className="font-semibold mb-4">Interactive Case Study</h3>
            <div className="space-y-3">
              {CASE.map(([k,label],i) => rc[k] && (
                <div key={k} className="flex gap-3">
                  <div className="flex flex-col items-center"><div className="h-7 w-7 rounded-full bg-[hsl(var(--brand-gold)/0.2)] flex items-center justify-center text-xs font-bold text-amber-700">{i+1}</div>{i<CASE.length-1 && <div className="w-px flex-1 bg-border my-1" />}</div>
                  <div className="pb-2"><div className="text-xs font-medium text-muted-foreground uppercase">{label}</div><div className="text-sm mt-0.5">{rc[k]}</div></div>
                </div>
              ))}
            </div>
          </Card>
        ) : (
          SECTIONS.map(([key,label]) => c[key] && (
            <Card key={key} className="p-5">
              <h3 className="font-semibold text-sm text-amber-700 uppercase tracking-wide">{label}</h3>
              <p className="text-sm mt-2 leading-relaxed text-foreground/85">{c[key]}</p>
              {key === 'chart_illustration' && <div className="mt-3 rounded-lg border-2 border-dashed p-8 text-center text-xs text-muted-foreground">Ilustrasi chart tersedia pada PDF referensi (Academy → Materi Referensi)</div>}
            </Card>
          ))
        )}
      </div>

      <div className="mt-6"><RiskAlert compact /></div>
      <Button onClick={complete} disabled={saving || data.completed} className="w-full mt-4 h-11 bg-[hsl(var(--brand-ink))] text-white" data-testid="complete-lesson-button">{data.completed ? 'Sudah Selesai' : (saving ? 'Menyimpan...' : 'Tandai Selesai')}</Button>
    </MemberLayout>
  );
}
